import { render, staticRenderFns } from "./AdiPaiUnitaValutazioneIntegrataComponent.vue?vue&type=template&id=bc8e6cc6"
import script from "./AdiPaiUnitaValutazioneIntegrataComponent.vue?vue&type=script&lang=js"
export * from "./AdiPaiUnitaValutazioneIntegrataComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports